import React from "react";
import { HiOutlineBadgeCheck, HiDownload } from "react-icons/hi";

const skills = [
  "HTML",
  "CSS",
  "JavaScript",
  "TypeScript",
  "TailwindCSS",
  "ANTD",
  "ReactJS",
  "NextJS",
  "NodeJS",
  "Figma",
];

export default function About() {
  return (
    <section className="section-about">
      <div className="container">
        <div className="about-text">
          <div className="content">
            <h1 className="title">About Me.</h1>
            <p className="paragraph overflow-hidden">
              I am a Bachelor of Computer Science from BINUS University, that
              experienced as a website developer and currently I am working as a
              Front-end Developer.
              <br />
              <br />
              Now I am mostly working with frontend framework like ReactJS and
              TailwindCSS.
            </p>
          </div>
          <div className="content">
            <h1 className="title">Skills.</h1>
            <div className="skill-list">
              {skills.map((item, index) => (
                <div className="skill-item" key={index}>
                  <HiOutlineBadgeCheck />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="about-image">
          <img
            src={require("Assets/Images/Profile.png")}
            alt="Profile"
            className="h-52 md:h-80"
          />
          <a
            href={require("Assets/File/Muhamad_Fathur_ Rahman_CV.pdf")}
            className="btn-download"
            download="Muhamad Fathur Rahman - CV"
          >
            <span>Download CV</span>
            <HiDownload />
          </a>
        </div>
      </div>
    </section>
  );
}
